import { render, staticRenderFns } from "./userguide.vue?vue&type=template&id=389968ec&scoped=true&"
import script from "./userguide.vue?vue&type=script&lang=js&"
export * from "./userguide.vue?vue&type=script&lang=js&"
import style0 from "./userguide.vue?vue&type=style&index=0&id=389968ec&lang=scss&scoped=true&"
import style1 from "./userguide.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389968ec",
  null
  
)

export default component.exports